<template>
    <fieldset>
        <p>
            Separat integration for backend Enhanced Conversions via Google Ads API.
        </p>

        <div class="mb-3" v-if="oauthDone">
            <div class="alert alert-success mb-0">Google Ads OAuth ansluten.</div>
        </div>

        <div class="mb-3" v-if="!oauthDone">
            <oauth-auth-code-workflow
                provider="Google Ads"
                :initiator="route('integrations.googleAdsEnhanced.auth.initiate')"
                @success="handleOauthSuccess"
                @failure="handleOauthFailure"
            />
        </div>

        <div class="mb-3">
            <div class="input-group mb-1">
                <div class="input-group-prepend">
                    <div class="input-group-text">Google Ads Customer ID</div>
                </div>
                <input
                    type="text"
                    class="form-control"
                    required
                    pattern="^[0-9]+$"
                    v-model="customerId"
                    @input="onUpdate"
                />
            </div>
            <p class="small italic">T.ex. <code>1234567890</code> (utan bindestreck)</p>
        </div>

        <div class="mb-3">
            <div class="input-group mb-1">
                <div class="input-group-prepend">
                    <div class="input-group-text">Conversion Action ID</div>
                </div>
                <input
                    type="text"
                    class="form-control"
                    required
                    pattern="^[0-9]+$"
                    v-model="conversionActionId"
                    @input="onUpdate"
                />
            </div>
            <p class="small italic">T.ex. <code>123456789</code></p>
        </div>

        <div class="mb-3" v-if="oauthDone">
            <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                @click="resetOauth"
            >
                Koppla om OAuth
            </button>
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
import OauthAuthCodeWorkflow from "../oauth-auth-code-workflow.vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const customerId = ref(null);
const conversionActionId = ref(null);
const accessToken = ref(null);
const refreshToken = ref(null);
const tokenExpiresAt = ref(null);
const oauthConnectedAt = ref(null);
const oauthDone = computed(() => {
  return !!refreshToken.value;
});
const serializedValue = computed(() => {
  return {
    customer_id: customerId.value,
    conversion_action_id: conversionActionId.value,
    access_token: accessToken.value,
    refresh_token: refreshToken.value,
    token_expires_at: tokenExpiresAt.value,
    oauth_connected_at: oauthConnectedAt.value
  };
});
function handleOauthSuccess([newAccessToken, newRefreshToken, expiresInSeconds]) {
  if (!newRefreshToken) {
    handleOauthFailure("No refresh token in OAuth response");
    return;
  }
  accessToken.value = newAccessToken || null;
  refreshToken.value = newRefreshToken;
  tokenExpiresAt.value = expiresInSeconds ? new Date(Date.now() + expiresInSeconds * 1000).toISOString().slice(0, 19).replace("T", " ") : null;
  oauthConnectedAt.value = new Date().toISOString().slice(0, 19).replace("T", " ");
  onUpdate();
}
function handleOauthFailure(error) {
  console.log(error);
}
function resetOauth() {
  accessToken.value = null;
  refreshToken.value = null;
  tokenExpiresAt.value = null;
  oauthConnectedAt.value = null;
  onUpdate();
}
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    customerId.value = modelValue.value.customer_id;
    conversionActionId.value = modelValue.value.conversion_action_id;
    accessToken.value = modelValue.value.access_token;
    refreshToken.value = modelValue.value.refresh_token;
    tokenExpiresAt.value = modelValue.value.token_expires_at;
    oauthConnectedAt.value = modelValue.value.oauth_connected_at;
  }
}, {
  immediate: true
});
</script>
